<template>
  <div class="pc-activity-header">
    <header>
      <a :href="pcTujiaHost" target="_blank" title="途家网首页" class="tujia-logo"></a>
      <ul class="nav-list">
        <li>
          <a :href="pcTujiaHost" class="home-link" target="_blank">首页</a>
        </li>
        <li>
          <a :href="pcTravelHost" target="_blank">发现</a>
        </li>
      </ul>
      <div class="header-search">
        <span class="log-reg">
          <a :href="loginUrl">{{loginLabel}}</a>
          <span>|</span>
          <a id="btnHeaderLogin" :href="logupUrl" class="reg">{{logupLabel}}</a>
        </span>
      </div>
    </header>
  </div>
</template>
<script>
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      loginUrl: '',
      loginLabel: '登录',
      logupLabel: '注册',
      logupUrl: ''
    }
  },
  computed: {
    isLoginCpd() {
      if (
        Cookies.get(`${this.tujiaDomain}_PortalContext_UserId`) &&
        Cookies.get(`${this.tujiaDomain}_PortalContext_UserId`) !== '0'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    isLoginCpd: {
      handler() {
        if (this.isLoginCpd) {
          this.loginLabel = '我的途家'
          this.logupLabel = '[退出]'
          this.logupUrl = `${this.passportHost}/PortalSite/Logout?returnUrl=${
            window.location.href
          }`
          this.loginUrl = `${this.pcTujiaHost}/UserInfo/OrderList/`
        } else {
          this.loginLabel = '登录'
          this.logupLabel = '注册'
          this.logupUrl = `${this.passportHost}/PortalSite/Register/`
          this.loginUrl = `${this.passportHost}/PortalSite/LoginPage/?srcUrl=${
            window.location.href
          }`
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.pc-activity-header {
  background: #fff;
  header {
    height: 40px;
    width: 100%;
    max-width: 1190px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 12px;
    .tujia-logo {
      width: 130px;
      height: 40px;
      background: url(https://staticfile.tujia.com/PortalSite2/Images/tujia-logo.png)
        no-repeat left center;
      float: left;
    }
    .nav-list {
      float: left;
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        float: left;
        height: 40px;
        padding: 0 16px;
        line-height: 40px;
      }
    }
    .header-search {
      float: right;
      margin-top: 14px;
      .log-reg {
        span {
          margin: 0 8px;
        }
        .reg {
          color: #ff6600;
        }
      }
    }
    a {
      text-decoration: none;
      color: #666666;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}
</style>
